import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  const [activeSlug, setActiveSlug] = useState('all');
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    setActiveSlug(slug);
    navigate(`/category/${slug}`);
  };

  return (
    <section className="py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg md:text-xl font-heading text-foreground-900">
            分类浏览
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleCategoryClick(cat.slug)}
              className={`whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-full transition-all duration-200 cursor-pointer ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
              <span className={`text-xs ${activeSlug === cat.slug ? 'text-background-50/70' : 'text-foreground-400'}`}>
                {cat.count}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}